module.exports = [{
      plugin: require('/root/project/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/root/project/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Lato:400,700"]}},
    },{
      plugin: require('/root/project/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://4491d8e992974505bfe0c60732d3ef69@sentry.io/1474843","environment":"production"},
    },{
      plugin: require('/root/project/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
